import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { CategoriesService } from 'src/app/services/categories.service'
import { MatSnackBar, MatDialog } from '@angular/material'
import { ModalConfirmComponent } from '../../../../components/modal-confirm/modal-confirm.component'
import { Location } from '@angular/common'

@Component({
  selector: 'app-subcategories-list',
  templateUrl: './subcategories-list.component.html',
  styleUrls: ['./subcategories-list.component.scss'],
})
export class subCategoriesListComponent implements OnInit {
  public headersTable: string[] = ['heading', 'order', 'status', 'actions']
  public subCategories: any[] = []
  public categoryId: string
  public category: string

  constructor (
    public categoriesService: CategoriesService,
    public snackBar: MatSnackBar,
    private readonly location: Location,
    private readonly dialog: MatDialog,
    private readonly route: ActivatedRoute,
  ) {}

  ngOnInit () {
    this.categoryId = this.route.snapshot.paramMap.get('categoryID')
    this.categoriesService.findOne(this.categoryId).then(
      response => {
        this.category = response.heading
      },
      error => {
        console.log(error)
        this.snackBar.open(error.error.message)
      },
    )
    this.listCategories()
  }

  listCategories () {
    this.categoriesService.listSubCategories(this.categoryId).then(
      response => {
        this.subCategories = response
      },
      error => {
        console.log(error)
        this.snackBar.open(error.error.message)
      },
    )
  }

  remove (id) {
    this.dialog
      .open(ModalConfirmComponent, {
        width: '500px',
        data: {
          text: 'Deseja remover essa Subcategoria?',
          buttonConfirmText: 'Remover',
        },
      })
      .afterClosed()
      .toPromise()
      .then(async result => {
        if (result && result !== 'cancel') {
          return this.categoriesService.deleteSubCategories(id).then(
            async response => {
              this.listCategories()
              this.snackBar.open('Subcategoria removida com sucesso.')
            },
            error => {
              console.log(error)
              this.snackBar.open(error.error.message)
            },
          )
        }
      })
      .catch(err => {
        this.snackBar.open(err.message)
      })
  }
}
